import { BAILocale } from '.';
import ms_MY from 'antd/es/locale/ms_MY';

const localeValue: BAILocale = {
  lang: 'ms',
  antdLocale: ms_MY,
};

export default localeValue;
